import axios from 'axios'
import { camelCase } from '../../../modules/string_converter'
import { i18n } from '../../../plugins/i18n'

export const companiesOriginalTagGroupsTag = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
  },
  mutations: {
    prepareConnect(state) {
      state.loading = true
    },
    readTagSuccess(state, payload) {
      const result  = {}
      for (const [key, value] of Object.entries(payload.data.attributes)) {
        result[camelCase(key)] = value
      }
      state.data = result
      state.loading = false
    },
    stopLoading(state) {
      state.loading = false
    },
  },
  actions: {
    readOriginalTag({ commit, rootState }) {
      commit('prepareConnect')
      const companyUuid = rootState.route.params.company_uuid
      const tagGroupKind = rootState.route.params.tag_group_kind
      const tagId = rootState.route.params.tag_id

      return axios
        .get('/api/companies/' + companyUuid + '/original/tag_groups/' + tagGroupKind + '/tags/' + tagId + '.json')
        .then(res => {
          commit('readTagSuccess', res.data)
        })
        .catch(err => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
        })
    },
    createTag({ commit, rootState }, name) {
      commit('prepareConnect')
      const companyUuid = rootState.route.params.company_uuid
      const tagGroupKind = rootState.route.params.tag_group_kind

      return axios
        .post('/api/companies/' + companyUuid + '/original/tag_groups/' + tagGroupKind + '/tags.json', {
          original_tag: {
            name: name
          }
        })
        .then(res => {
          commit('readTagSuccess', res.data)
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.created', { value: i18n.t('models.originalTagGroup.tag.modelName') }) }, { root: true })
          return true
        })
        .catch(err => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
          return false
        })
    },
    updateTag({ commit, rootState }, name) {
      commit('prepareConnect')
      const companyUuid = rootState.route.params.company_uuid
      const tagGroupKind = rootState.route.params.tag_group_kind
      const tagId = rootState.route.params.tag_id

      return axios
        .patch('/api/companies/' + companyUuid + '/original/tag_groups/' + tagGroupKind + '/tags/' + tagId + '.json', {
          original_tag: {
            name: name
          }
        })
        .then(res => {
          commit('readTagSuccess', res.data)
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.updated', { value: i18n.t('models.originalTagGroup.tag.modelName') }) }, { root: true })
          return true
        })
        .catch(err => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
          return false
        })
    },
    deleteTag({ commit, rootState }, tagId) {
      commit('prepareConnect')
      const companyUuid = rootState.route.params.company_uuid
      const tagGroupKind = rootState.route.params.tag_group_kind

      return axios
        .delete('/api/companies/' + companyUuid + '/original/tag_groups/' + tagGroupKind + '/tags/' + tagId + '.json')
        .then(() => {
          commit('stopLoading')
          return true
        })
        .catch(err => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
          return false
        })
    }
  }
}
